import React from 'react';
import PropTypes from 'prop-types';
import {useComponentProps} from 'helpers/hooks/utils';
import StyledEditorMenuButtonTaskList
  from 'components/atoms/Editors/EditorMenuButtonTaskList/EditorMenuButtonTaskList.styles';

const EditorMenuButtonTaskList = React.forwardRef((props, ref) => {
  const innerProps = useComponentProps(props, 'EditorMenuButtonTaskList');

  return <StyledEditorMenuButtonTaskList buttonRef={ref} {...innerProps} />
});

EditorMenuButtonTaskList.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ])
};

export default EditorMenuButtonTaskList;
